import moment from "moment"
export type FinAidField =
    | "today_date"
    | "today_month"
    | "today_year"
    | "bbay_start"
    | "bbay_end"
    | "term_start_date"
    | "campus"
    | "total_grants"
    | "total_loans"
    | "total_fin_aid_eligibility"
    | "total_cost"
    | "balance_not_covered_by_fin_aid"
    | "est_remaining_balance"
    | "payment_per_month"
    | "number_of_payments"
    | "costs"
    | "grants"
    | "loans"
    | "disbursements"

const finAidFieldLabels: Partial<Record<FinAidField, string>> = {
    today_date: "Today's Date",
    today_month: "Today's Month",
    today_year: "Today's Year",
    bbay_start: "BBAY Start Date",
    bbay_end: "BBAY End Date",
    term_start_date: "Start Date",
    campus: "Campus",
    total_grants: "Pell Grant",
    total_loans: "Loans Available (net)",
    total_fin_aid_eligibility: "Total Financial aid eligibility",
    total_cost: "Total cost",
    balance_not_covered_by_fin_aid: "Balance not covered by FA",
    est_remaining_balance: "Estimated remaining balance",
    payment_per_month: "payment/month",
    number_of_payments: "# payments"
}

export const getFinAidFieldLabel = (field: FinAidField) => finAidFieldLabels[field]

export const getTodayFinAidFields = (dateFormat: string) => {
    const today = moment()

    return {
        today_date: today.format(dateFormat),
        today_month: today.format("MMMM"),
        today_year: today.format("YYYY")
    }
}
